import React from 'react';
import { Image, StyleSheet } from 'react-native';

import { COLOR, __WEB__ } from '../../../constants/styles';

export default (ArrowRight = props => {
  return (
    <Image
      style={[styles.arrowIcon, props.style, props.disabled ? styles.disabled : null]}
      source={require('../../../../resources/arrow-right.png')}
      resizeMode="contain"
    />
  );
});

const styles = StyleSheet.create({
  arrowIcon: {
    width: 7,
    height: 13,
  },
  disabled: {
    tintColor: COLOR.textDisabled,
  },
});
